package one.healthium.ui.compose.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf
import one.healthium.ui.compose.components.AppTopBarStyle
import one.healthium.ui.compose.theme.styles.AppButtonStyle
import one.healthium.ui.compose.theme.styles.AppNavigationBarStyle
import one.healthium.ui.compose.theme.styles.AppNavigationRailStyle
import one.healthium.ui.compose.theme.styles.BannerStyle
import one.healthium.ui.compose.theme.styles.ContentCardStyle
import one.healthium.ui.compose.theme.styles.DailyTaskStyle
import one.healthium.ui.compose.theme.styles.HealthKitBannerStyle
import one.healthium.ui.compose.theme.styles.LogControlStyle
import one.healthium.ui.compose.theme.styles.LogWaterControlStyle
import one.healthium.ui.compose.theme.styles.LogWeightControlStyle
import one.healthium.ui.compose.theme.styles.ProfileStyle
import one.healthium.ui.compose.theme.styles.TutorialStyle
import one.healthium.ui.compose.theme.styles.UScreenStyle

@Composable
fun AppTheme(
    theme: AppThemeBase = Themes.ifa(),
    content: @Composable () -> Unit
) {
    val appColors = theme.colors

    MaterialTheme(
        colorScheme = lightColorScheme(
            background = appColors.windowBackground,
            primary = appColors.primary,
            surface = appColors.surface,
            onSurface = appColors.onSurface,
            outlineVariant = gray_2,
        ),
    ) {
        CompositionLocalProvider(
            LocalAppColors provides appColors,
            LocalAppShapes provides theme.shapes,
            LocalAppTextStyles provides theme.textStyles,
            LocalBaseTheme provides theme,
        ) {
            CompositionLocalProvider(
                LocalAppTopBarDefaults provides (theme.appTopBarStyle ?: AppTopBarStyle()),
                content = content,
            )
        }
    }
}

object AppTheme {
    val textStyles: AppTextStyle @Composable get() = LocalAppTextStyles.current
    val colors: AppColors @Composable get() = LocalAppColors.current
    val shapes: AppShapes @Composable get() = LocalAppShapes.current
    val appTopBarStyle: AppTopBarStyle @Composable get() = LocalAppTopBarDefaults.current
    val dailyTaskStyle: DailyTaskStyle @Composable get() = LocalBaseTheme.current.dailyTasksStyle
    val contentCardStyle: ContentCardStyle? @Composable get() = LocalBaseTheme.current.contentCardStyle
    val logWaterControlStyle: LogWaterControlStyle @Composable get() = LocalBaseTheme.current.logWaterControlStyle
    val logWeightControlStyle: LogWeightControlStyle? @Composable get() = LocalBaseTheme.current.logWeightControlStyle
    val logControlStyle: LogControlStyle? @Composable get() = LocalBaseTheme.current.logControlStyle
    val profileStyle: ProfileStyle @Composable get() = LocalBaseTheme.current.profileStyle
    val tutorialStyle: TutorialStyle? @Composable get() = LocalBaseTheme.current.tutorialStyle
    val defaultButtonStyle: AppButtonStyle? @Composable get() = LocalBaseTheme.current.defaultButtonStyle
    val navigationBarStyle: AppNavigationBarStyle @Composable get() = LocalBaseTheme.current.navigationBarStyle
    val navigationRailStyle: AppNavigationRailStyle @Composable get() = LocalBaseTheme.current.navigationRailStyle
    val healthKitBannerStyle: HealthKitBannerStyle @Composable get() = LocalBaseTheme.current.healthKitBannerStyle
    val bannerStyle: BannerStyle @Composable get() = LocalBaseTheme.current.bannerStyle
    val uscreenStyle: UScreenStyle @Composable get() = LocalBaseTheme.current.uscreenStyle
}

val LocalAppTextStyles = staticCompositionLocalOf<AppTextStyle> { error("No AppTextStyles provided") }
val LocalAppColors = staticCompositionLocalOf<AppColors> { error("No AppColor provided") }
val LocalAppShapes = staticCompositionLocalOf<AppShapes> { error("No AppShapes provided") }
val LocalAppTopBarDefaults = staticCompositionLocalOf<AppTopBarStyle> { error("No TopAppBarStyle provided") }
val LocalBaseTheme = staticCompositionLocalOf<AppThemeBase> { error("No AppThemeBase provided") }
